export default __webpack_public_path__ + "static/media/Slider-1.0670f60a.jpg";